export default {"src":"/_next/static/media/add-address.50181b5d.svg","height":16,"width":16};